module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-slider-component vue-slider-horizontal",
    class: this.disabled ? 'vue-slider-disabled' : '',
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    ref: "slider",
    staticClass: "vue-slider",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('div', {
    ref: "dot0",
    staticClass: "vue-slider-hover vue-slider-dot",
    attrs: {
      "id": "dot0"
    },
    on: {
      "mousedown": function($event) {
        _vm.handleMouseDown($event, 0)
      },
      "touchstart": function($event) {
        _vm.handleMouseDown($event, 0)
      }
    }
  }, [_c('span', {
    staticClass: "vue-slider-tooltip-top vue-slider-tooltip-wrap"
  }, [_vm._t("tooltip", [_c('span', {
    staticClass: "vue-slider-tooltip"
  }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[0]) : _vm.val[0]))])], {
    value: _vm.val[0],
    index: 0
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "dot1",
    staticClass: "vue-slider-hover vue-slider-dot",
    attrs: {
      "id": "dot1"
    },
    on: {
      "mousedown": function($event) {
        _vm.handleMouseDown($event, 1)
      },
      "touchstart": function($event) {
        _vm.handleMouseDown($event, 1)
      }
    }
  }, [_c('span', {
    staticClass: "vue-slider-tooltip-top vue-slider-tooltip-wrap"
  }, [_vm._t("tooltip", [_c('span', {
    staticClass: "vue-slider-tooltip"
  }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[1]) : _vm.val[1]))])], {
    value: _vm.val[1],
    index: 1
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "process",
    staticClass: "vue-slider-process"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-078658aa"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-slider.vue
// module id = 974
// module chunks = 0